import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';

class AccessRapid {

  private root: HTMLElement;
  private tabs: HTMLButtonElement[]; 
  private panels: HTMLElement[];
  private swipers: Swiper[] = [];

  constructor(root: HTMLElement) {

    this.root = root;

    this.tabs = Array.from(
      root.querySelectorAll('[data-tab-trigger]')
    );

    this.panels = Array.from(
      root.querySelectorAll('[data-tab-panel]')
    );

    this.initTabs();
    this.initSwipers();
  }

  /* =========================================================
    Tabs
  ========================================================== */

  initTabs() {

    this.tabs.forEach((tab, index) => {

      tab.addEventListener('click', () => {
        this.activate(index);
      });

      tab.addEventListener('keydown', (e) => {
        this.handleKeyboard(e, index);
      });

    });

  }

    activate(index: number) {

    this.tabs.forEach((tab, i) => {

        const isActive = i === index;

        tab.classList.toggle('is-active', isActive);

        tab.setAttribute(
        'aria-selected',
        String(isActive)
        );

    });

    this.panels.forEach((panel, i) => {

        const isActive = i === index;

        panel.classList.toggle('is-active', isActive);

        if (isActive) {
        panel.removeAttribute('hidden');
        } else {
        panel.setAttribute('hidden', '');
        }

    });

    this.tabs[index]?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'nearest',
    });

    requestAnimationFrame(() => {
        this.swipers[index]?.update();
    });

    }

  handleKeyboard(
    event: KeyboardEvent,
    currentIndex: number
  ) {

    let nextIndex = currentIndex;

    switch (event.key) {

      case 'ArrowRight':
        nextIndex =
          (currentIndex + 1) % this.tabs.length;
        break;

      case 'ArrowLeft':
        nextIndex =
          (currentIndex - 1 + this.tabs.length)
          % this.tabs.length;
        break;

      case 'Home':
        nextIndex = 0;
        break;

      case 'End':
        nextIndex = this.tabs.length - 1;
        break;

      default:
        return;
    }

    event.preventDefault();
    this.activate(nextIndex);
    this.tabs[nextIndex].focus();
  }

  /* =========================================================
    Swipers
  ========================================================== */

    private initSwipers() {

    const swiperElements =
        this.root.querySelectorAll<HTMLElement>(
        '[data-swiper]'
        );

    swiperElements.forEach((element) => {

        const swiper = new Swiper(element, {

        modules: [Navigation],

        slidesPerView: 'auto',
        spaceBetween: 12,

        observer: true,
        observeParents: true,

        breakpoints: {

            640: {
            slidesPerView: 'auto'
            },

            1024: {
            slidesPerView: 'auto'
            }

        }

        });

        this.swipers.push(swiper);

    });

    }

}

/* =========================================================
  Export with init() method
========================================================= */

export default {
  init() {
    const components = document.querySelectorAll<HTMLElement>(
      '[data-acces-rapides]'
    );

    components.forEach((component) => {
      new AccessRapid(component);
    });
  }
};
